import React, { useState, useEffect } from "react";
import { useAuth } from "../../services/context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import "./Perfil.css";
import MeusDados from "./meusDados/MeusDados";
import MeusPedidos from "./meusPedidos/MeusPedidos";
import InsigneCoins from "./insigneCoins/InsigneCoins";
import MeusLivros from "./meusLivros/MeusLivros";
import Sidebar from "./Sidebar/Sidebar";
import Logout from "../login/Logout";

const Perfil = ({ handleLogout }) => {
  const { user, loading } = useAuth(); // Include loading state from useAuth
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("meus-dados");
  const main = process.env.REACT_APP_MAIN;

  useEffect(() => {
    if (!loading && !user) { // Check if loading is false before redirecting
      navigate(main + "login");
    }
  }, [loading, user, navigate, main]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  if (loading) {
    return <div>Loading...</div>; // Render loading state while authenticating
  }
  return (
   
  <div className="perfil-container">
      <div className="profile-container">

        <div className="breadcrumb">
          <Link to={main}>Início</Link>
          <span> / </span>
          <p className="active">Meu Perfil</p>
        </div>

        <div className="profile-header">
          <h2>Meu Perfil</h2>
        </div>

        <div className="profile-flex">
          <div className="perfil-sidebar">
            <Sidebar activeTab={activeTab} onTabChange={handleTabChange} />
          </div>
          <div className="content">
            {activeTab === "meus-dados" && <MeusDados />}

            {activeTab === "meus-livros" && <MeusLivros />}
            {activeTab === "meus-pedidos" && <MeusPedidos user={user} />}
            {activeTab === "insignecoins" && <InsigneCoins />}
          </div>
        </div>
      </div>

      <div className="logout-btn-perfil">
        <Logout onLogout={handleLogout} />
      </div>
    </div>
  )
};

export default Perfil;
